import {GetWarehouseResponse} from '@dms/api/warehouse';

export const warehouseMock: GetWarehouseResponse = {
  id: '855bd140-6054-4d4b-beeb-2adbf5ee89b4',
  warehouseNumber: 'WH01',
  name: 'Hyundai CZ',
  defaultSupplierId: 'a024ebfe-b790-47b2-ac85-da86ac458869',
  warehousePricing: 'FIFO',
  branchId: '659b8f3b-4923-4d2c-8938-a2e397a5c2c3',
  companyBillingInfoId: '2d191d67-e985-40e4-9b66-1d327f7a4074',
  workItemGroupId: 'a024ebfe-b790-46fe-b242-0437fb15adfc',
  allowServiceOrderIssue: true,
  commercialOrderMarginMinimum: 10,
  stockNumberPrefix: 'HCZ01-',
  receiveNoteSeriesId: '5568682c-62de-4d4f-80cc-9fb38d710815',
  receiveNoteTemplateId: 'cd30cc52-da18-43e4-b0a6-6f24fffe78a1',
  issueNoteSeriesId: '727d0e9d-edeb-44e8-b3d3-eca3dae1781c',
  issueNoteTemplateId: 'd5b3b20d-0e7a-417a-811c-9dd371e2c3b2',
  issueNoteCorrectionSeriesId: '468b11a9-93ee-449c-bb2f-2fb7e2d3e98a',
  issueNoteCorrectionTemplateId: '34b02a4b-8192-46fe-b242-0437fb15adfc',
  creditNoteSeriesId: '427f583f-b951-4132-b7f1-a06ec1e86585',
  creditNoteTemplateId: '6be38b90-a31a-4eaa-9fa9-aca1d5f3c906',
  salesPriceCalculation: 'MARKUP_ON_BASE',
  basePriceSource: 'AVG_PURCHASE',
  salePriceMarkupPercent: 30,
  blockPricingSettingOnArticle: false,
  unitSalesPriceWithVat: false,
  isFastTrack: false,
  dummyWarehouse: false,
  allSuppliers: false,
  suppliers: [
    {id: 'a024ebfe-b790-47b2-ac85-da86ac458869'},
    {id: 'b3183e22-bb0b-4321-9cf9-ed20ad0300e8'},
  ],
  allowDirectSaleIssue: true,
  allowedDirectSaleVariants: [
    '57dfc221-0516-46b9-93f2-d845e47b365e',
    '1f298c5a-df09-4abe-ba61-57b7b0f2a66e',
    'e7694c31-23f4-4a0d-a356-e0ca26c873d8',
    'a8ef5382-2b94-4b5f-9699-a59a7d412915',
    '7fe62930-bb7f-4322-8750-92242b57c971',
    '88f74ea3-e6ce-4db0-8cf2-0104b1332679',
  ],
  authorizationProfileId: 'bab7f1dc-f7de-4c4f-a59a-76ebe05c23ea',
  defaultManufacturerId: '04911c52-e6fc-11ee-bd3d-0242ac120002',
  currency: 'CZK',
  created: '2024-03-28T17:06:02.703Z',
  createdBy: '0b592803-9bef-4840-b0ab-9a2cb6ded726',
  updated: '2025-01-03T06:53:15.512Z',
  updatedBy: '98d07dd3-9946-48ad-8392-fb2d77739e7e',
};

export const warehouseWithoutDefaultManufacturerMock: GetWarehouseResponse = {
  ...warehouseMock,
  defaultManufacturerId: undefined,
};
